import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initTestimonialCarouselV2() {
    const tcsSection = document.querySelectorAll('.testimonial-carousel-v2-section');

    tcsSection.forEach(section => {
        const tcsContentSliderEl = section.querySelector('.tcs-content-slider');
        if (!tcsContentSliderEl) {
            return;
        }

        if (tcsContentSliderEl.swiper) {
            return;
        }

        const SwiperClass = typeof Swiper !== 'undefined' ? Swiper : window.Swiper;
        if (!SwiperClass) {
            return;
        }

        new SwiperClass(tcsContentSliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            autoHeight: true,
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                prevEl: section.querySelector('.tcs-button-prev'),
                nextEl: section.querySelector('.tcs-button-next'),
            },
            pagination: {
                el: section.querySelector('.tcs-pagination'),
                clickable: true,
            },
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialCarouselV2);
} else {
    initTestimonialCarouselV2();
}